import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";

const segmentsPageData = (id) => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            template {
                                ... on WpTemplate_Segments {
                                    segmentsRichContent {
                                        hero {
                                            category
                                            header
                                            secondHeader
                                            text
                                            buttons {
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                            image {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                        anchorNav {
                                            label
                                            target
                                        }
                                        keyBenefits {
                                            slug
                                            header
                                            description
                                            benefits {
                                                icon {
                                                    ...wpImageFluid
                                                }
                                                title
                                                description
                                            }
                                        }

                                        # SECTION: Trade Layer Lottie animation
                                        tradeLayer {
                                            slug
                                            header
                                            description
                                            bottomText
                                            lottieSrc {
                                                localFile {
                                                    publicURL
                                                }
                                            }
                                            lottieSrcMobile {
                                                localFile {
                                                    publicURL
                                                }
                                            }
                                        }

                                        # SECTION: UseCases Cards
                                        solutionsOverview {
                                            slug
                                            header
                                            description
                                            items {
                                                title
                                                description
                                                image {
                                                    ...wpImage
                                                }
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                                secondButton {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                        }

                                        # SECTION: Image Section
                                        imageSection {
                                            category
                                            title
                                            text
                                            slug
                                            variant
                                            image {
                                                ...wpImageFluid
                                            }
                                            items {
                                                category
                                                title
                                                text
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                        }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                    }
                }
            }
                                        }
                                }
`
    );
    return getCurrentRichContent(data, id, "segmentsRichContent");
};

export { segmentsPageData };
